import superadmin from "../Middlewares/superadmin";

import Index from "../../Components/Pages/SuperAdmin/Index";
import PartnersIndex from "../../Components/Pages/SuperAdmin/Partners/Index";
import ActivityLogsIndex from "../../Components/Pages/SuperAdmin/ActivityLogs/Index";
import EmailLogsIndex from "../../Components/Pages/SuperAdmin/EmailLogs/Index";

export const routes = [
    {
        path    : '/superadmin',
        name    : 'superadmin-home',
        redirect: '/superadmin/dashboard'
    },
    {
        path: '/superadmin/dashboard',
        name: 'superadmin-dashboard',
        component: Index,
        meta: {
            title: "Dashboard",
            icon: 'mdi-view-dashboard',
            menu: 'left-superadmin',
            middleware: [
                superadmin
            ],
        }
    },
    {
        path: '/superadmin/partners',
        name: 'superadmin-partners',
        component: PartnersIndex,
        meta: {
            title: "Partners",
            icon: 'mdi-account-group',
            menu: 'left-superadmin',
            middleware: [
                superadmin
            ],
        }
    },
    {
        path: '/superadmin/email-logs',
        name: 'superadmin-email-logs',
        component: EmailLogsIndex,
        meta: {
            title: "Email Logs",
            icon: 'mdi-send-clock',
            menu: 'left-superadmin',
            middleware: [
                superadmin
            ],
        }
    },
    {
        path: '/superadmin/email-templates',
        name: 'superadmin-email-templates',
        component: Index,
        meta: {
            title: "Email Templates",
            icon: 'mdi-email-newsletter',
            menu: 'left-superadmin',
            middleware: [
                superadmin
            ],
        }
    },
    {
        path: '/superadmin/activity-logs',
        name: 'superadmin-activity-logs',
        component: ActivityLogsIndex,
        meta: {
            title: "Activity Logs",
            icon: 'mdi-gesture-tap',
            menu: 'left-superadmin',
            middleware: [
                superadmin
            ],
        }
    },
    {
        path: '/superadmin/platform-settings',
        name: 'superadmin-platform-settings',
        component: Index,
        meta: {
            title: "Platform Settings",
            icon: 'mdi-cogs',
            menu: 'left-superadmin',
            middleware: [
                superadmin
            ],
        }
    },
]
